"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var copy_to_clipboard_1 = __importDefault(require("copy-to-clipboard"));

var rangeUtils_1 = require("./rangeUtils");

exports.copyRange = function (range) {
  var textContent = rangeUtils_1.getRangeTextContent(range);

  if (textContent) {
    copy_to_clipboard_1.default(textContent.trim());
  }
};